/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { createPaymentAccountSignal, Icon } from '@millionshow/client-libs';
import { PromotionCardData } from '../../interfaces/promotion-cards.interface';
import { PROMOTION_CARDS } from '../../const/promotion-cards.const';
import { RouterLink } from '@angular/router';
import GalleryComponent from './components/gallery/gallery.component';
import SponsorComponent from '../home/components/sponsor/sponsor.component';
import BroadcastScheduleCalendarComponent from './components/broadcast-schedule-calendar/broadcast-schedule-calendar.component';
import { SettingService } from '@millionshow/api-client';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-inquiry',
  imports: [
    CommonModule,
    Icon,
    RouterLink,
    GalleryComponent,
    SponsorComponent,
    BroadcastScheduleCalendarComponent,
  ],
  templateUrl: './inquiry.page.html',
})
export default class InquiryPage {
  private readonly settingService = inject(SettingService);

  mediaCard: PromotionCardData = PROMOTION_CARDS.find(
    card => card.id === 'media-channel'
  )!;

  email = toSignal(
    this.settingService.settingControllerFindByKey({ key: 'agritex_email' })
  );

  paymentAccount = createPaymentAccountSignal('agritex');
}
